import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router'
import TrialLayout from '../TrialLayout/TrialLayout'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import ReactPlayer from 'react-player'
import styled, { withTheme } from 'styled-components'

const PlayerWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
  max-width: 100%;
  height: auto;
  margin-bottom: 45px;
`

const VideoThumbnailContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const RelatedColumn = styled(Col)`
  margin-top: 15px;

  img {
    width: 100%;
    max-width: 335px;
    max-height: 188px;
  }

  div {
    height: fit-content;
    margin-top: 4px;
    overflow: hidden;
    font-weight: bold;
    color: var(--clr-grey-3-to-white);
  }
`

const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  iframe {
    position: absolute;
  }
`

const Header = styled.h5`
  font-weight: bold;
  margin: 0px;
  color: var(--clr-grey-3-to-white);
`

let RelatedVideo = ({ video, query, createUserEvent }) => {
  return (
    <RelatedColumn xs={6} lg={4} title={video.title} className="related-videos">
      <Link
        key={'videos_' + video.pk}
        to={{ pathname: '/videos/' + video.slug, query: query }}
        onClick={() =>
          createUserEvent({
            category: 'videos',
            data: { action: 'relatedVideoClick', video: { pk: video.pk } }
          })
        }
        className="animated fadeIn"
      >
        <img src={video.thumb} alt={`${video.title} Thumbnail`} />
        <div>{video.title}</div>
      </Link>
    </RelatedColumn>
  )
}

const Videos = ({
  videos,
  videoId,
  relatedVideos,
  noSideBar,
  noSearchBar,
  query,
  createUserEvent,
  language,
  isFetching
}) => {
  const [video, setVideo] = useState(null)
  const translated = messages[language]

  useEffect(() => { 
    if (!videoId) return

    const [currentVideo] = videos.filter(
      video => video.pk === parseInt(videoId, 10)
    )

    setVideo(currentVideo) 
    
  }, [videoId, videos])
  
  if (!video) {
    return <div>Loading...</div>
  }
  
  return (
    <TrialLayout
      currentVideo={video.pk}
      isFetching={isFetching}
      title={`${video.title}`}
      relatedType="related"
      relatedId={video.pk}
      contentType="video"
      noSideBar={noSideBar}
      noSearchBar={noSearchBar}
    >
      <If condition={!!video}>
        <div>
          <Row>
            <Col md={12}>
              <PlayerWrapper>
                <StyledReactPlayer
                  url={video.url}
                  controls
                  width="100%"
                  height="100%"
                  onStart={() =>
                    createUserEvent({
                      category: 'videos',
                      data: { action: 'videoPlay', video: { pk: video.pk } }
                    })
                  }
                />
              </PlayerWrapper>
            </Col>
          </Row>
          <If condition={relatedVideos.length > 0}>
            <Row>
              <Header>{translated.related}</Header>
            </Row>
            <VideoThumbnailContainer>
              {relatedVideos.map((video, key) => (
                <RelatedVideo
                  key={`related_video_${key}`}
                  video={video}
                  query={query}
                  createUserEvent={createUserEvent}
                />
              ))}
            </VideoThumbnailContainer>
          </If>
        </div>
      </If>
    </TrialLayout>
  )
}

Videos.propTypes = {
  videos: PropTypes.array.isRequired,
  videoId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  relatedVideos: PropTypes.array,
  noSideBar: PropTypes.bool,
  noSearchBar: PropTypes.bool,
  query: PropTypes.object,
  isFetching: PropTypes.bool
}

export default LanguageProvider(withTheme(Videos))



// WEBPACK FOOTER //
// ./src/components/Videos/Videos.js